<template>
    <div class="line2slots flex-level">
        <p class="m-0 gray-80" :class="[{'title' : isTitle}, {'subtitle' : isSubtitle}]">
            <slot name="left" />
        </p>
        <div class="flex-right">
            <p class="m-0 gray-80" :class="[{'title' : isTitle}, {'subtitle' : isSubtitle}]">
                <slot name="right" />
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isTitle: {
                required: false,
                default: false
            },
            isSubtitle: {
                required: false,
                default: false
            }
        },
        data(){
            return {
            }
        },
    }
</script>

<style scoped lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.line2slots{
    .title{
        font-size: 17px;
        font-weight: 700;
        color: $gray-100 !important;
    }
    .subtitle{
        font-weight: 600;
        color: $gray-100 !important;
    }
}
</style>